import * as React from 'react';
import { ITagOption, Tags } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { definitions } from '../../actions/filterTags/definitions';
import { IStateTag, updateTags } from '../../actions/filterTags';
import { getOffersCount } from '../../actions/offersData';
import { ClearTagsAdornment, ExpandCollapseAdornment } from '../../components/TagAdornments';
import { TagLayout } from '../../components/TagLayout';
import { getTags } from '../../selectors/filters';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getTagIcon } from './getTagIcon';

const displayModeOptions = {
  maxLines: 1,
  expandCollapseAdornment: (isExpanded: boolean) => <ExpandCollapseAdornment isExpanded={isExpanded} />,
  isFoldable: true,
  isFolded: true,
};

export const FilterTags = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const tags = useSelector(getTags);

  const clearAllTags = React.useCallback(() => {
    tags.forEach(tag => {
      const definition = definitions.get(tag.keyName);
      if (definition) {
        const onDeleteAction = definition.onDeleteAction(tag.value, { skipUpdateOffersCount: true });
        if (onDeleteAction) {
          dispatch(onDeleteAction);
        }
      }
    });
    dispatch(getOffersCount());
    dispatch(updateTags());
  }, [dispatch, tags]);

  const options = React.useMemo<ITagOption[]>(
    () =>
      tags.map(tag => {
        const mappedTag = {
          label: tag.label,
          value: JSON.stringify(tag.value), // Китовые теги требует уникальное значение в value.
          icon: getTagIcon(tag),
        };

        return mappedTag;
      }),
    [tags],
  );

  const deleteTag = React.useCallback(
    (option: ITagOption) => {
      const tag = tags.find(tag => JSON.stringify(tag.value) === option.value) as IStateTag;
      const definition = definitions.get(tag.keyName);

      if (definition) {
        dispatch(definition.onDeleteAction(tag.value));
      }
    },
    [dispatch, tags],
  );

  if (!tags.length) {
    return null;
  }

  return (
    <TagLayout>
      <Tags
        options={options}
        onClose={deleteTag}
        displayModeOptions={displayModeOptions}
        rightAdornment={<ClearTagsAdornment tagsNumber={options.length} onAllTagsDeleted={clearAllTags} />}
      />
    </TagLayout>
  );
};
